import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '~/routes/components/AuthProvider'
import { DateInput } from 'semantic-ui-calendar-react'
import { handleErrors, parseDate } from '~/utils/helpers'
import Dialog from '~/components/Dialog'
import { DownloadService } from '~/api/services/downloadFiles'
import notify from '~/components/Notify'

interface Props {
  openExport: boolean
  handleClose: () => void
}

const Export: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { openExport, handleClose } = props
  const { systemData: { languages, logged: { languageId } } } = useAuth()
  const languageLocal = languages.find(language => language.id === languageId)

  const [dateExport, setDateExport] = useState('')
  const [isBusy, setIsBusy] = useState(false)

  const handleKeyPress = (event) => {
    event.preventDefault();
  }

  function renderDatePicker() {
    return <DateInput
      name='date'
      autoComplete='off'
      placeholder={t('Select date')}
      closable
      clearIcon={'close'}
      clearable
      localization={languageLocal.code}
      onKeyPress={handleKeyPress}
      closeOnMouseLeave={false}
      dateFormat={'DD.MM.YYYY'}
      className={'datePicker'}
      value={dateExport}
      iconPosition='left'
      onChange={(e, data) => setDateExport(data.value)}
    />
  }

  async function handleSubmit() {
    setIsBusy(true)
    try {
      await DownloadService.downloadFile('milk-money/tours/export', 'tour', { date: parseDate(dateExport) })
      notify(t('Successfully downloaded tour file'), 'success')
      setDateExport('')
      handleClose()
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    textHeader={t('Export tour file')}
    isLoading={isBusy}
    isDialogOpen={openExport}
    textSubmit={t('Export')}
    textClose={t('Close')}
    textContent={renderDatePicker()}
    handleClose={() => {
      setDateExport('')
      handleClose()
    }}
    disableSubmit={dateExport === ''}
    handleSubmit={() => handleSubmit()}
    type={'abort'}
  />
}
export default Export